/**
 * Extracts a human-friendly error message from Kiota/ProblemDetails/ValidationProblemDetails errors.
 * Gracefully falls back to a generic message when structure is unknown.
 */
export function extractErrorMessage(error: unknown, fallback = "Er is een fout opgetreden"): string {
  try {
    const e = error as any;

    const status = e?.status ?? e?.statusCode ?? e?.responseStatusCode;
    const errorsObj =
      e?.errors ??
      e?.response?.errors ??
      e?.body?.errors ??
      e?.additionalData?.errors;

    // Prefer aggregated validation messages for 400 responses.
    if (status === 400 && errorsObj && typeof errorsObj === "object") {
      const messages = Object.values(errorsObj as Record<string, unknown>)
        .flat()
        .filter((m) => typeof m === "string" && m.trim().length > 0) as string[];
      if (messages.length) {
        return messages.join(" ");
      }
    }

    // ProblemDetails pattern: combine title/detail when available.
    if (typeof e?.title === "string" || typeof e?.detail === "string") {
      const title = typeof e?.title === "string" ? e.title : "";
      const detail = typeof e?.detail === "string" ? e.detail : "";
      const combined = `${title} ${detail}`.trim();
      if (combined) {
        return combined;
      }
    }

    // Fallback to message property.
    if (typeof e?.message === "string" && e.message.trim().length > 0) {
      return e.message;
    }
  } catch {
    // ignore and fallback
  }
  return fallback;
}
